import Button from '@zenbusiness/common-components/Button';

import Grid from '@mui/material/Grid';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const IntroPageContainer = superstyled({
  tag: Grid,
  styles: ({ theme }) => ({
    width: '100vw',
    maxWidth: '105rem',
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      width: '75vw',
      gridTemplateColumns: '1fr 2fr',
      alignContent: 'stretch'
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      width: '90vw'
    },
    [theme.breakpoints.between('xs', 'md')]: {
      width: '100vw'
    }

  })
});

export const IntroPageHeader = superstyled({
  tag: Grid,
  styles: ({ theme }) => ({
    width: '100%',
    margin: '0rem 0rem 1.25rem 0rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: '60rem'
    }
  })
});

export const IntroPageContent = superstyled({
  tag: Grid,
  styles: ({ theme }) => ({
    width: '100%',
    padding: '0rem 0.75rem 0rem 0.75rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: '60rem',
      padding: 0
    }
  })
});

export const IntroPageButtonsContainer = superstyled({
  tag: Grid,
  styles: ({ theme }) => ({
    marginTop: '1.25rem',
    padding: '0rem 0.75rem 0rem 0.75rem',
    gap: '1rem',
    [theme.breakpoints.up('md')]: {
      padding: 0
    }
  })
});
export const IntroPageButtons = superstyled({
  name: 'IntroPageButton',
  slot: 'IntroPageButton',
  tag: Button,
  styles: {
    width: '100%',
    padding: '1.25rem 1.5rem',
    borderRadius: '1rem',
    textTransform: 'none'
  }
});
export const IntroPageFooterButton = superstyled({
  tag: IntroPageButtons,
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.focus90.main}`,
    color: theme.palette.focus90.main,
    textTransform: 'capitalize',
    boxShadow: 'unset',
    width: '100%',
    marginBottom: '1rem',
    '&.isSecondary': {
      color: theme.palette.focus00.main
    }
  })
});
